import React, { useContext } from "react";

import { useTranslation } from "react-i18next";

import { WalletItem } from "@components-shared/desktop/inputs/WalletItem";
import { useRootAppStore } from "@hooks";
import { DepositContext } from "@state/context/payment/DepositContext";
import { isGamesTheme } from "@utils";
import { observer } from "mobx-react-lite";

export default observer(function SelectedDepositWallet() {
	const { currentFormData, gamesWallet } = useContext(DepositContext);

	const { t } = useTranslation("payment");

	const rootStore = useRootAppStore();

	const selectedWallet = rootStore.userAuthStore.userAccounts?.find((w) => {
		return w.accountTypeId === currentFormData?.bettingAccountTypeId;
	});

	return (
		<>
			<div className="label">{t("DEPOSIT.DEPOSIT_ACCOUNT")}</div>
			<ul className="wallet">
				<WalletItem
					wallet={isGamesTheme() ? gamesWallet : selectedWallet}
					isDisabled
					isDefaultChecked
					shouldRegister={false}
					isList={true}
				/>
			</ul>
		</>
	);
});
